<template>
  <div class="stats my-3">
    <span @click="toggleStat(stat)" class="stat cursor-pointer" :class="{ 'disabled': stat.disabled }" v-for="stat in stats" :key="stat.name">
      <span class="colorSquare"  :style="{ 'background-color': stat.color }" />
      <small :class="{ 'text-muted': stat.disabled }">{{ getPrettyStatName(stat.name) }}</small>
    </span>
  </div>
</template>

<style scoped>
.stats {
  text-align: center;
}
.stat {
  padding: 0 1em;
  display: inline-block;
}
.colorSquare {
  width: 13px;
  height: 13px;
  display: inline-block;
  border-radius: 4px;
  margin-bottom: -2px;
  margin-right: 3px;
}
.disabled .colorSquare {
  border: 2px solid var(--border);
  background-color: var(--white) !important;
}
</style>

<script>
import { getPrettyStatName } from '@/reports/components/ReportUtils'
export default {
  data () {
    return {
      
    }
  },
  methods: {
    getPrettyStatName,
    toggleStat(stat) {
      stat.disabled = !stat.disabled
    }
  },
  props: {
    stats: { required: true, type: Array }
  }
}
</script>


// WEBPACK FOOTER //
// src/reports/components/graphs/GraphLegend.vue